import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const DocusignActions = createActionGroup({
  source: 'Docusign',
  events: {


    'Get Signing Url': props<{ envelopeId: string }>(),
    'Get Signing Url Success': props<{ url: string }>(),
    'Get Signing Url Failure': props<{ error: string }>(),

    'Open Embed Signing': props<{ envelopeId: string }>(),


    'Send Docusign Envelope Button Pressed': emptyProps(),

    'Send Docusign Envelope': emptyProps(),
    'Send Docusign Envelope Success': emptyProps(),
    'Send Docusign Envelope Failure': props<{ error: string }>(),


  }
});
